import { addEvents } from './_dom-evennts';
export function componetParser(components: any) {
    components.forEach(component => {
        addEvents(new component());
    });
};